<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-6 col-12">
        <div class="card mb-4 border-0 shadow-sm">
          <div class="card-header pb-0 text-start bg-white d-flex justify-content-between align-items-center">
            <div>
              <h6 class="font-weight-bolder text-gradient text-info">NUEVA OFERTA LABORAL</h6>
              <p class="text-sm mb-0">Completa la información detallada para generar la carta de la oferta.</p>
            </div>
            <button class="btn btn-sm bg-gradient-dark d-lg-none" @click="showModal = true">
              <i class="fas fa-eye me-2"></i>PREVIEW
            </button>
          </div>
          <div class="card-body px-4">
            <!-- Sección 1: Metadatos y Postulado -->
            <div class="row">
              <div class="col-12">
                <h6 class="text-uppercase text-body text-xs font-weight-bolder mb-3 bg-light p-2 rounded">
                  <i class="fas fa-file-alt me-2"></i>1. Datos del Documento y Postulado
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Código de Referencia</label>
                <input class="form-control form-control-sm" v-model="job.details.metadatos_documento.codigo_referencia" placeholder="G-0000-000" />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Fecha de Emisión</label>
                <input class="form-control form-control-sm" v-model="job.details.metadatos_documento.fecha_emision" />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Nombre del Postulado</label>
                <input class="form-control form-control-sm" v-model="job.details.datos_postulado.nombre_completo" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Identificación (DUI/ID)</label>
                <input class="form-control form-control-sm" v-model="job.details.datos_postulado.numero_identificacion" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Teléfono de Contacto</label>
                <input class="form-control form-control-sm" v-model="job.details.datos_postulado.telefono_contacto" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Nacionalidad</label>
                <input class="form-control form-control-sm" v-model="job.details.datos_postulado.nacionalidad" disabled />
              </div>
            </div>

            <!-- Sección 2: Detalles de la Oferta -->
            <div class="row mt-4">
              <div class="col-12">
                <h6 class="text-uppercase text-body text-xs font-weight-bolder mb-3 bg-light p-2 rounded">
                  <i class="fas fa-briefcase me-2"></i>2. Detalles de la Oferta Laboral
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Nombre de la Empresa</label>
                <input class="form-control form-control-sm" v-model="job.details.detalles_oferta.nombre_empresa" />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Nombre del Cargo</label>
                <input class="form-control form-control-sm" v-model="job.details.detalles_oferta.nombre_cargo" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label text-xs font-weight-bold">Sueldo Anual ($)</label>
                <input class="form-control form-control-sm" type="number" v-model="job.details.detalles_oferta.promedio_salarial_anual" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label text-xs font-weight-bold">Horas Semanales</label>
                <input class="form-control form-control-sm" type="number" v-model="job.details.detalles_oferta.horas_semanales" />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Ubicación</label>
                <input class="form-control form-control-sm" v-model="job.details.detalles_oferta.ubicacion_cargo" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label text-xs font-weight-bold">Tipo Empleo</label>
                <input class="form-control form-control-sm" v-model="job.details.detalles_oferta.tipo_empleo" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label text-xs font-weight-bold">Tipo Contrato</label>
                <input class="form-control form-control-sm" v-model="job.details.detalles_oferta.tipo_contrato" />
              </div>
              <div class="col-12 mb-3">
                <label class="form-label text-xs font-weight-bold">Tareas y Responsabilidades (una por línea)</label>
                <textarea class="form-control form-control-sm" rows="3" v-model="rawTasks" placeholder="Ayudar a los clientes..."></textarea>
              </div>
            </div>

            <!-- Sección 3: Beneficios y Condiciones -->
            <div class="row mt-4">
              <div class="col-12">
                <h6 class="text-uppercase text-body text-xs font-weight-bolder mb-3 bg-light p-2 rounded">
                  <i class="fas fa-hand-holding-usd me-2"></i>3. Beneficios y Condiciones Económicas
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Pago Semanal Total ($)</label>
                <input class="form-control form-control-sm" type="number" v-model="job.details.beneficios.pago_semanal_total" />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xs font-weight-bold">Beneficios Adicionales (uno por línea)</label>
                <textarea class="form-control form-control-sm" rows="2" v-model="rawBenefits" placeholder="Posibilidad de crédito..."></textarea>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label text-xs font-weight-bold">Costo Total Proceso ($)</label>
                <input class="form-control form-control-sm" type="number" v-model="job.details.condiciones_economicas_proceso.costo_total_proceso" />
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label text-xs font-weight-bold">Plazo Postulación (días)</label>
                <input class="form-control form-control-sm" type="number" v-model="job.details.condiciones_economicas_proceso.plazo_postulacion_dias" />
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label text-xs font-weight-bold">Política de Reembolso</label>
                <input class="form-control form-control-sm" v-model="job.details.condiciones_economicas_proceso.politica_reembolso" />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <label class="form-label text-xs font-weight-bold">Archivo Adjunto (Relacionado)</label>
                <input type="file" class="form-control form-control-sm" @change="onChange">
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-12">
                <button :disabled="disableBtn" class="btn bg-gradient-success w-100" @click="createJob">
                  <i class="fas fa-plus-circle me-2"></i>{{ disableBtn ? 'CREANDO...' : 'CREAR OFERTA LABORAL' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Preview Column (Larger Scale) -->
      <div class="col-lg-6 col-12 d-none d-lg-block">
        <div class="sticky-top" style="top: 2rem; z-index: 100;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="text-uppercase text-body text-xs font-weight-bolder mb-0">VISTA PREVIA DEL DOCUMENTO</h6>
            <button class="btn btn-xs bg-gradient-info mb-0" @click="showModal = true">
              <i class="fas fa-expand-arrows-alt me-2"></i>VER PANTALLA COMPLETA
            </button>
          </div>
          <div class="card shadow-lg bg-light overflow-hidden border-0" style="height: 85vh; border-radius: 12px;">
            <div class="preview-scroll-area overflow-auto h-100">
              <div class="preview-zoom-container" style="transform: scale(0.65); transform-origin: top center; width: 100%; position: relative; margin-bottom: -150mm;">
                <job-offer-letter-preview :details="job.details" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fullscreen Modal Preview -->
    <div v-if="showModal" class="custom-modal-backdrop" @click="showModal = false">
      <div class="custom-modal-content card shadow-lg" @click.stop>
        <div class="card-header d-flex justify-content-between align-items-center p-3">
          <h6 class="mb-0">VISTA PREVIA DE LA CARTA</h6>
          <button class="btn btn-close text-dark" @click="showModal = false">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="card-body p-0 overflow-auto text-center" style="max-height: 85vh;">
          <div class="py-4 d-inline-block">
            <job-offer-letter-preview :details="job.details" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {post} from "@/utils/httpRequest";
import UploadFile from "@/utils/uploadFile";
import Swal from "sweetalert2";
import JobOfferLetterPreview from "@/components/JobOfferLetterPreview.vue";

export default {
  name: "JobCreate",
  components: {
    JobOfferLetterPreview
  },
  data: () => ({
    showModal: false,
    disableBtn: false,
    tempFileRelated: null,
    rawTasks: "Ayudar a los clientes con las tareas de cuidado personal, incluido bañarse, arreglarse y vestirse.\nProporcionar recordatorios de medicamentos y asistencia con los tratamientos prescritos.\nAyudar con tareas ligeras de limpieza y preparación de comidas.\nAcompañar a los clientes a citas o salidas según sea necesario.\nMonitorear e informar cambios en la condición del cliente a la enfermera supervisora o al coordinador de atención.\nFomentar un entorno de apoyo y atención para los clientes y sus familias.",
    rawBenefits: "450(k) Posibilidad de crédito para vivienda propia.\nOportunidades de formación continua y desarrollo profesional.\nAmbiente de trabajo de apoyo con un equipo colaborativo.\nSomos un empleador que ofrece igualdad de oportunidades y valoramos la diversidad en nuestra fuerza laboral.",
    job: {
      details: {
        metadatos_documento: {
          fecha_emision: new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }),
          codigo_referencia: "00000 0504 966027702366 2024"
        },
        datos_postulado: {
          nombre_completo: "xxxx xxxx xxxx",
          numero_identificacion: "xxxx-x",
          telefono_contacto: "xxxx-xxxx",
          nacionalidad: "xxxx"
        },
        detalles_oferta: {
          nombre_empresa: "",
          nombre_cargo: "ASISTENTE DE SALUD DOMICILIARIA",
          promedio_salarial_anual: 96000,
          tipo_empleo: "Tiempo completo",
          tipo_contrato: "Indefinido",
          ubicacion_cargo: "Long Island, Nueva York",
          horas_semanales: 40,
          tareas_responsabilidades: []
        },
        beneficios: {
          pago_semanal_total: 2000,
          beneficios_adicionales: []
        },
        condiciones_economicas_proceso: {
          costo_total_proceso: 1130,
          plazo_postulacion_dias: 2,
          politica_reembolso: "100% DE REEMBOLSO DE MANERA INMEDIATA"
        }
      }
    }
  }),
  watch: {
    rawTasks(val) {
      this.job.details.detalles_oferta.tareas_responsabilidades = val.split('\n').filter(t => t.trim() !== '');
    },
    rawBenefits(val) {
      this.job.details.beneficios.beneficios_adicionales = val.split('\n').filter(b => b.trim() !== '');
    }
  },
  created() {
    this.job.details.detalles_oferta.tareas_responsabilidades = this.rawTasks.split('\n');
    this.job.details.beneficios.beneficios_adicionales = this.rawBenefits.split('\n');
  },
  methods: {
    async onChange(e){
      this.tempFileRelated = e.target.files[0];
    },
    async createJob(){
      this.disableBtn = true
      try {
        let file_data = null;
        if (this.tempFileRelated) {
          const {data} = await UploadFile.upload("job-offers/add-file", {file: this.tempFileRelated});
          file_data = data;
        }
        
        await post("job-offers/create", {
          ...this.job.details,
          file_related: file_data
        });
        
        await Swal.fire('Oferta creada correctamente', '', 'success');
        window.location.reload();
      } catch (err) {
        Swal.fire('Error', err.response?.data?.message || 'Error al conectar con el servidor', 'error');
        this.disableBtn = false;
      }
    }
  }
}
</script>

<style scoped>
.preview-zoom-container {
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  background-color: #fff;
}
.text-gradient.text-info {
  background-image: linear-gradient(310deg, #21d4fd 0%, #2152ff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.italic { font-style: italic; }

.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-modal-content {
  background: white;
  width: 90%;
  max-width: 900px;
  height: 90vh;
  border-radius: 15px;
  overflow: hidden;
}

.preview-scroll-area::-webkit-scrollbar {
  width: 6px;
}

.preview-scroll-area::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}
</style>
